import type { MessageKey } from '@bookingdei/i18n/message-key';
import type { User } from '../mock/seeds/schema-types';
import type { IconName } from './icon';
import { surfaceOrigin } from './surface-links';

// The other dashboards this account can open from the customer dashboard — one
// sign-in, no sign-out (client decision 30 Oct 2026, amending DR-38's "role choice
// only at website sign-in"). The target dashboard takes the role itself on load
// (API-13 switch-role), so these are plain links. An account without a business gets
// the website's merchant sign-up instead (FR-B1 — it upgrades the same account).
export interface RoleSwitchLink {
  id: 'business' | 'add_business' | 'admin';
  key: MessageKey;
  icon: IconName;
  href: string;
}

export function roleSwitchLinks(user: User | undefined): RoleSwitchLink[] {
  if (!user) return [];
  const roles: readonly string[] = user.roles ?? [];
  const links: RoleSwitchLink[] = [];
  if (roles.includes('merchant') || roles.includes('staff')) {
    const merchant = surfaceOrigin('merchant');
    if (merchant) links.push({ id: 'business', key: 'account.switch_business', icon: 'business', href: `${merchant}/` });
  } else {
    const website = surfaceOrigin('website');
    if (website) links.push({ id: 'add_business', key: 'nav.add_business', icon: 'business', href: `${website}/merchant-signup` });
  }
  if (roles.includes('admin')) {
    const admin = surfaceOrigin('admin');
    if (admin) links.push({ id: 'admin', key: 'account.switch_admin', icon: 'shield', href: `${admin}/` });
  }
  return links;
}
